import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SelectTemplate } from 'src/app/@amiga-pyme/select/templates/select.template';
import { IProvider } from 'src/app/pages/gestion/providers/provider.interface';
import { ProviderService } from 'src/app/pages/gestion/providers/provider.service';
import { IEventPurchase } from '../purchases.interface';
import { ProviderSelectionService } from './provider-selection.service';

@Component({
  selector: 'pg-purchase-provider-selection',
  templateUrl: './provider-selection.component.html'
})
export class ProviderSelectionComponent
  extends SelectTemplate
  implements OnInit
{
  providerSelected: IProvider;
  fg: FormGroup;
  dataTable: IProvider[];
  select = {
    provider: {
      typeSelect: 'single',
      openDialog: false,
      id: null
    }
  };

  @Output('stepsEmitter') stepsEmitter = new EventEmitter<IEventPurchase>();
  openProviderCreate = false;

  constructor(
    private fb: FormBuilder,
    private providerSelectionService: ProviderSelectionService,
    private providerService: ProviderService
  ) {
    super(null, providerService);
  }

  ngOnInit() {
    this.fg = this.fb.group({
      provider: [{ value: null, disabled: true }, [Validators.required]]
    });
  }

  nextPage() {
    this.providerSelectionService.setData(this.providerSelected);
    this.stepsEmitter.emit({
      action: 'next',
      data: null
    } as IEventPurchase);
  }

  onSelectedProvider(event: IProvider) {
    if (event != null) {
      this.providerSelected = event;
      this.fg.get('provider').setValue(this.providerSelected.name);
    }
    this.select.provider.openDialog = false;
  }
}
